import moment from "moment";
import { useStyles } from "./ActionPlanDueDateCell.styles";
import { useMemo } from "react";
import MainTag from "components/MainTag";
import { MainTagTypeEnum } from "components/MainTag/MainTagInterfaces";
import { useTranslation } from "react-i18next";
import { RCA_STATUSES } from "constants/constants";
import { isLate } from "utilities/utilities";
import { IActionPlanDueDateCell } from "./ActionPlanDueDateCellInterfaces";
import useDateFormat from "hooks/useDateFormat";

const ActionPlanDueDateCell = ({ actionPlan }: IActionPlanDueDateCell) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { formatDate } = useDateFormat();

    const showLateTag = useMemo(() => {
        return (
            isLate(new Date(actionPlan.due_date).toISOString()) &&
            actionPlan.status.status_id !== RCA_STATUSES.COMPLETED
        );
    }, [actionPlan.due_date, actionPlan.status.status_id]);

    const showDueTodayTag = useMemo(() => {
        return (
            moment(new Date(actionPlan.due_date).toISOString()).isSame(moment(), "day") &&
            actionPlan.status.status_id !== RCA_STATUSES.COMPLETED
        );
    }, [actionPlan.due_date, actionPlan.status.status_id]);

    return (
        <div className={`${classes.descriptionWrapper} ${showLateTag ? classes.textRed : ""}`}>
            <span>{formatDate(actionPlan.due_date)}</span>
            {showLateTag && <MainTag type={MainTagTypeEnum.ERROR}>{t("rca.rca_library.late")}</MainTag>}
            {showDueTodayTag && <MainTag type={MainTagTypeEnum.WARNING}>{t("rca.rca_library.due_today")}</MainTag>}
        </div>
    );
};

export default ActionPlanDueDateCell;
